import * as React from 'react';
import { ToolbarColorTheme, ToolbarItem, useToolbarColorThemeContext } from '../PublicTypes';
import { SplitButtonContainerStyleName } from '../styles/ButtonStyles';
import { Button, ButtonProps } from './Button';
import { Dropdown } from './Dropdown';

export const SplitSecondaryIdSuffix = '-secondary';

export interface SplitButtonProps extends Omit<ButtonProps, 'buttonRef' | 'selected' | 'showLabel'> {
  /** Items to display in the dropdown menu */
  dropdownItems: ToolbarItem[];

  /** Dropdown button label */
  dropdownLabel: string;

  /** Tab index for dropdown button */
  dropdownTabIndex?: number;
}

export function SplitButton(props: SplitButtonProps): React.ReactElement {
  const colorTheme: ToolbarColorTheme = useToolbarColorThemeContext();

  const { dropdownItems, dropdownLabel, dropdownTabIndex, ...buttonProps } = props;

  return (
    <div className={SplitButtonContainerStyleName(colorTheme)}>
      <Button {...buttonProps} buttonType={'splitButton'} showLabel={false} />
      <Dropdown
        disabled={props.disabled}
        dropdownItems={dropdownItems}
        iconId={props.iconId + SplitSecondaryIdSuffix}
        id={props.id + SplitSecondaryIdSuffix}
        isHidden={props.isHidden}
        label={dropdownLabel}
        omitIcon={true}
        testId={props.testId + '-menu'}
        tabIndex={dropdownTabIndex}
      />
    </div>
  );
}
